<template>
  <div class="digital-view">
    <section class="site-hero digital-hero" :style="heroStyle">
      <div class="site-hero__inner">
        <h1>数字化成果</h1>
        <p v-for="(paragraph, index) in pageIntro" :key="index">{{ paragraph }}</p>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>成果展示</h2></div>
      </div>
      <div class="page-shell">
        <el-tabs v-model="activeTab" stretch>
          <el-tab-pane label="产业数字化改造成果展示" name="system">
            <div class="card-grid system-grid">
              <article v-for="item in pagedDigitalSystems" :key="item.title" class="result-card panel-card">
                <img :src="item.image" :alt="item.title">
                <div class="result-body">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.text }}</p>
                </div>
              </article>
            </div>
            <div v-if="digitalSystems.length > pageSize" class="pagination-row">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="systemPageNo"
                :page-size="pageSize"
                :total="digitalSystems.length"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="产业数字化系统研发成果展示" name="device">
            <div class="card-grid device-grid">
              <article v-for="item in pagedDigitalDevices" :key="item.title" class="result-card panel-card">
                <div class="device-figure"><img :src="item.image" :alt="item.title"></div>
                <div class="result-body">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.text }}</p>
                </div>
              </article>
            </div>
            <div v-if="digitalDevices.length > pageSize" class="pagination-row">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="devicePageNo"
                :page-size="pageSize"
                :total="digitalDevices.length"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { getSitePage } from "@/api/website";

export default {
  name: "DigitalResultsView",
  data() {
    return {
      activeTab: "system",
      pageSettings: {
        bannerImage: "/assets/banner.png",
        intro: []
      },
      digitalSystems: [],
      digitalDevices: [],
      systemPageNo: 1,
      devicePageNo: 1,
      pageSize: 12
    };
  },
  computed: {
    pageIntro() {
      return this.pageSettings.intro && this.pageSettings.intro.length ? this.pageSettings.intro : [];
    },
    heroStyle() {
      const image = this.pageSettings.bannerImage || "/assets/banner.png";
      return {
        "--page-banner-image": `url("${image}")`
      };
    },
    pagedDigitalSystems() {
      const start = (this.systemPageNo - 1) * this.pageSize;
      return this.digitalSystems.slice(start, start + this.pageSize);
    },
    pagedDigitalDevices() {
      const start = (this.devicePageNo - 1) * this.pageSize;
      return this.digitalDevices.slice(start, start + this.pageSize);
    }
  },
  created() {
    getSitePage("digitalResults").then((res) => {
      const data = res.data || {};
      const pageSettings = data.pageSettings || {};
      this.pageSettings = pageSettings.digitalResults || this.pageSettings;
      this.digitalSystems = data.digitalSystems || [];
      this.digitalDevices = data.digitalDevices || [];
      this.systemPageNo = 1;
      this.devicePageNo = 1;
    });
  }
};
</script>

<style lang="less" scoped>
.digital-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    var(--page-banner-image) center / cover no-repeat;
}

.content-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
  /deep/ .el-tabs__item{
    font-size: 20px;
    font-weight: 600;
  }
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.result-card {
  overflow: hidden;
}

.result-card img {
  width: 100%;
  aspect-ratio: 1 / 0.72;
  object-fit: cover;
}

.device-figure {
  display: grid;
  place-items: center;
  background: #f5f9ff;
}

.device-figure img {
  object-fit: contain;
}

.result-body {
  padding: 22px;
}

.result-body h3 {
  margin: 0 0 10px;
  font-size: 22px;
}

.result-body p {
  margin: 0;
  color: var(--muted);
}

.pagination-row {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 1040px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .page-shell /deep/ .el-tabs__item {
    font-size: 15px;
  }

  .result-body {
    padding: 18px;
  }

  .result-body h3 {
    font-size: 20px;
  }

  .result-body p {
    font-size: 14px;
  }
}
</style>
